export default "__VITE_ASSET__Bco2JPZp__"